import type { PropsWithChildren, ReactNode } from 'react'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'

export { IconGridCard }

type Props = PropsWithChildren<{
  icon: ReactNode
}>

const IconGridCard = ({ children, icon }: Props) => {
  return (
    <Grid
      size={{ xs: 12, lg: 6, xl: 3 }}
      sx={{ display: 'flex', position: 'relative' }}
    >
      <Card sx={{ flexGrow: 1 }}>
        <CardContent
          sx={{
            gap: 4,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              opacity: 0.05,
              fontSize: 300,
              lineHeight: 0,
              overflow: 'hidden',
            }}
          >
            <Box sx={{ transform: 'translate(25%, 25%) rotate(10deg)' }}>
              {icon}
            </Box>
          </Box>

          {children}
        </CardContent>
      </Card>
    </Grid>
  )
}
